/**
 * Centralized application state
 */
export const AppState = {
    // Current active tab
    currentTab: 'podcasts',

    // Current podcast context
    currentPodcastId: null,
    currentPodcastTitle: null,

    // Pagination state
    currentEpisodePage: 0,
    currentPodcastPage: 0,

    // Interval references for cleanup
    intervals: {
        workerCheck: null,
        servicesHealth: null,
        healthMonitoring: null,
        stats: null
    },

    // Episode filters state
    episodeFilters: {
        search: '',
        transcriptionStatus: '',
        downloadStatus: '',
        dateFrom: '',
        dateTo: ''
    }
};

/**
 * Clear all intervals
 */
export function clearAllIntervals() {
    Object.keys(AppState.intervals).forEach(key => {
        if (AppState.intervals[key]) {
            clearInterval(AppState.intervals[key]);
            AppState.intervals[key] = null;
        }
    });
}

/**
 * Set an interval and track it
 */
export function setTrackedInterval(name, callback, delay) {
    // Clear existing interval if any
    if (AppState.intervals[name]) {
        clearInterval(AppState.intervals[name]);
    }
    AppState.intervals[name] = setInterval(callback, delay);
    return AppState.intervals[name];
}

/**
 * Clear a specific interval
 */
export function clearTrackedInterval(name) {
    if (AppState.intervals[name]) {
        clearInterval(AppState.intervals[name]);
        AppState.intervals[name] = null;
    }
}

